import PageHome from '@/pages/front/pageHome'
import PageCourses from '@/pages/front/pageCourse'
import PageCourse from '@/pages/front/course/pageCourse'
import TrainList from '@/page/continueEdu/train/list'
import Train from '@/page/continueEdu/train/model'
import NewsList from '@/page/continueEdu/news/list'
import News from '@/page/continueEdu/news/model'
import ModulePay from '@/page/modules/pay/pay'
import ModuleWXPay from '@/page/modules/pay/wxPay'
import ModulePayResult from '@/page/modules/pay/result'

const routes = [
  {
    path: '/home',
    name: '首页',
    component: PageHome,
    meta: {
      // keepAlive: true // 需要被缓存
    }
  },
  {
    path: '/course',
    name: '课程',
    component: PageCourses,
    meta: {
      // keepAlive: true // 需要被缓存
    }
  },
  {
    path: '/courseDetail/:id',
    name: '课程详情',
    component: PageCourse
  },
  {
    path: '/trainList',
    name: '培训信息',
    component: TrainList
  },
  {
    name: '培训信息详情',
    path: '/train/:id',
    component: Train,
    meta: {
      navClass: '/trainList' // 为了实现点击到详情页时维持顶部导航栏选中的状态
    }
  },
  {
    path: '/newsList',
    name: '新闻资讯',
    component: NewsList
  },
  {
    name: '新闻资讯详情',
    path: '/news/:id',
    component: News,
    meta: {
      navClass: '/newsList' // 为了实现点击到详情页时维持顶部导航栏选中的状态
    }
  },
  {
    path: '/coursePay/:id/:type/:businessId/:orgType/:result_url/:sign',
    name: '课程购买',
    component: ModulePay
  },
  {
    path: '/wxPay',
    name: '微信支付',
    component: ModuleWXPay
  },
  {
    path: '/payResult/:type/:businessId/:res_url',
    name: '购买结果',
    component: ModulePayResult
  }
]
export default routes



// WEBPACK FOOTER //
// ./src/routers/front.js